/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { ActionRequest, Asset, AssetMediaType, Channel, EntryPoint, Folder } from '@wit/vtv-x-foundation-lib';
import { AnyAction } from 'redux';
import { take, TakeEffect } from 'redux-saga/effects';

const NO_ENTRY_POINT = 'noEntryPoint';

export interface FolderInfoContext {
  entryAssetId: number;
  entryAsset?: Folder;
  entryPoint?: EntryPoint;
}

export interface ParentContext {
  entryAsset?: Asset;
  entryPoint: EntryPoint;
  relatedChannel?: Channel;
}

export enum ActionType {
  INIT = 'app/folderInfo/context/INIT',
  CLEAR = 'app/folderInfo/context/CLEAR',
}

export type InitContext = ActionRequest<
  ActionType.INIT,
  { ctx: FolderInfoContext; parentCtx?: ParentContext; channelId?: number }
>;
export type ClearContext = ActionRequest<ActionType.CLEAR, FolderInfoContext>;

export const ActionCreators = {
  init: (ctx: FolderInfoContext, parentCtx?: ParentContext, channelId?: number): InitContext => ({
    type: ActionType.INIT,
    meta: { ctx, parentCtx, channelId },
  }),
  clear: (context: FolderInfoContext): ClearContext => ({
    type: ActionType.CLEAR,
    meta: context,
  }),
};

export function getFolderContextId(ctx: FolderInfoContext) {
  return `${AssetMediaType.FOLDER}/${ctx.entryAssetId}/${ctx.entryPoint || NO_ENTRY_POINT}`;
}

// helper function that checks the action type and also the context
export function takeFolderCtx<T>(actionType: T, ctx: FolderInfoContext): TakeEffect {
  // first tries a reference comparing and then compares the contextId
  return take(
    (act: AnyAction) =>
      act.type === actionType && (act.meta === ctx || getFolderContextId(act.meta) === getFolderContextId(ctx))
  );
}
